<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Doc — Publicações: Nova e editar
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Como
        strong  criar
        |  e
        strong  editar
        |  uma publicação de documentos.

      .toast.toast-primary
        | Criar exige
        strong  Publicações → Publicações de documentos → Criar
        | . Editar exige
        strong  Publicações → Publicações de documentos → Alterar
        | .

      h5.h5 1. Nova publicação
      ol
        li Em
          strong  Doc → Publicações
          | , clique em
          strong  Nova
          |  (ou o botão equivalente de criação).
      figure.manual-figure
        img(:src="imgNova" alt="Formulário Nova Publicação")
      ol
        li Preencha
          strong  Descrição
          |  (obrigatório),
          strong  Número
          | ,
          strong  Ano
          |  e
          strong  Publicado em
          | .
        li Clique em
          strong  Salvar
          | .

      h5.h5 2. Editar
      ol
        li Abra a publicação (
          strong Exibir
          | ).
        li No rodapé, clique em
          strong  Editar
          | .
        li Ajuste os campos e
          strong  Salvar
          | .
      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgNova: require("@/assets/manuais/19a-doc-publicacoes-nova.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
